import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"
import _imports_0 from '../assets/speedprint_logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center login-logo" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1)
const _hoisted_2 = { class: "row mt-4 login-box" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "card text-dark bg-light" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "login", -1)
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "hasło", -1)
const _hoisted_8 = { class: "row mt-3" }
const _hoisted_9 = { class: "col-md-7 form-error" }
const _hoisted_10 = { class: "col-md-5 text-end" }
const _hoisted_11 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_12 = { class: "center-div" }

import { store } from "@/store";
  import { ActionTypes } from "@/store/speedprint/action-types";
  import { ref } from "vue";
  import { inject } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

  const emitter:any = inject('emitter');
  const user = ref('');
  const pass = ref('');
  const loading = ref(false);
  const failed = ref(false);
  const errMsg = ref('');

  const login = async () => {
    loading.value = true;
    failed.value = false;
    errMsg.value = '';
    await store.dispatch(ActionTypes.LOGIN, { username: user.value, password: pass.value })
      .catch((reason:any) => { loading.value = false; errMsg.value = reason.respMessage;  failed.value = true });
  }

return (_ctx: any,_cache: any) => {
  const _component_GridLoader = _resolveComponent("GridLoader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "card-body relative",
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (login()), ["enter"]))
          }, [
            _createElementVNode("div", null, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user).value = $event))
              }, null, 512), [
                [_vModelText, user.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pass).value = $event))
              }, null, 512), [
                [_vModelText, pass.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(errMsg.value), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (login()))
                }, "zaloguj się")
              ])
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_GridLoader, {
                      color: '#f1602a',
                      class: "center-div"
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})